import { render, staticRenderFns } from "./LeaveWork.vue?vue&type=template&id=76963e5c&"
import script from "./LeaveWork.vue?vue&type=script&lang=js&"
export * from "./LeaveWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports